// Add URL parser etc
import querystring from 'querystring'
import { LSTORAGE_COUNT_TO_SAVE, LSTORAGE_FILTER_DATA_KEY } from 'constants/flightResults'
import { CURRENCY_LOCALSTORAGE_KEY } from 'constants/hotels'
import { logConsole, groupCollapsedConsole } from 'utils/logError'
import langTranslate from 'locale'
import { formatCurrency, getConversionRate, getCurrencyByLocale, encodingValue } from 'utils/currencyHelper'
import { createBrowserHistory, createMemoryHistory } from 'history'
import { getFormattedDate } from 'utils/dateHelper'
import { DAYAFTERTOMORROW, TOMORROW } from 'constants/dates'
import { DOMAIN_COUNTRY_MAP, EXTENTION_BY_DOMAIN } from 'constants/domainConfig'
import { DOMAIN } from 'constants/base'
import { DEFAULT_POPULAR_DESTINATIONS, POPULAR_DESTINATIONS_BY_LOCALE } from 'constants/autoSuggest'

export const browserHistory = process.browser ? createBrowserHistory() : createMemoryHistory()
let timeoutId
export const resolveKeysInObjectsArrays = (p, o) => {
    const reducerFunction = (xs, x) => {
        return xs && xs[x] ? xs[x] : null
    }
    return p.reduce(reducerFunction, o)
}

export const isEmpty = obj => {
    if (obj instanceof Date) {
        return false
    }
    // null and undefined are "empty"
    if (obj == null || obj == 'undefined') {
        return true
    }

    const isNumber = value => Object.prototype.toString.call(value) === '[object Number]'
    const isNaN = value => isNumber(value) && value.toString() === 'NaN'

    if (isNumber(obj)) {
        return isNaN(obj)
    }

    /** Assume if it has a length property with a non-zero value
     * that that property is correct.
     */
    if (obj.length > 0) {
        return false
    }
    if (obj.length === 0) {
        return true
    }

    /** If it isn't an object at this point
     * it is empty, but it can't be anything *but* empty
     * Is it empty?  Depends on your application.
     */
    if (typeof obj !== 'object') {
        return true
    }

    /**  Otherwise, does it have any properties of its own?
     * Note that this doesn't handle
     * toString and valueOf enumeration bugs in IE < 9
     */
    const keys = Object.keys(obj)
    for (let i = 0, key = keys[i]; i < keys.length; i += 1) {
        if (hasOwnProperty.call(obj, key)) {
            return false
        }
    }
    return true
}

export const setCurrencyToLocalStorage = (curCode, curSymbol) => {
    if (curCode && curSymbol) {
        let currencyObj = {
            hotel: { value: { code: curCode, symbol: curSymbol }, e: 0 }
        }
        localStorage.setItem(CURRENCY_LOCALSTORAGE_KEY, JSON.stringify(currencyObj))
    }
}

export const toQueryString = (object, sep = '&', eq = '=') => {
    return querystring.stringify(object, sep, eq)
}

export const fromQueryString = (queryString, sep = '&', eq = '=') => {
    return querystring.parse(queryString, sep, eq)
}

export function getSearchUrlParams() {
    const searchUrl = location.search || ''
    let params = searchUrl
    if (searchUrl.indexOf('?') > -1) {
        params = searchUrl.slice(1)
    }

    const urlParam = fromQueryString(params)
    if (window.location.pathname.includes('/merchresults')) {
        if (isEmpty(urlParam.checkIn) || isEmpty(urlParam.checkOut)) {
            urlParam.checkIn = getFormattedDate(TOMORROW, 'DD/MM/YYYY')
            urlParam.checkOut = getFormattedDate(DAYAFTERTOMORROW, 'DD/MM/YYYY')
            urlParam.adults = 2
            urlParam.child = 0
            urlParam.num_rooms = 1
            return replaceQueryInUrl(browserHistory, urlParam, 'mrp')
        }
    }
    if (window.location.pathname.includes('/results')) {
        if (isEmpty(urlParam.chk_in) || isEmpty(urlParam.chk_out)) {
            urlParam.chk_in = getFormattedDate(TOMORROW, 'DD/MM/YYYY')
            urlParam.chk_out = getFormattedDate(DAYAFTERTOMORROW, 'DD/MM/YYYY')
            urlParam.adults = 2
            urlParam.adults1 = 2
            urlParam.num_rooms = 1
            return replaceQueryInUrl(browserHistory, urlParam)
        }
    }

    return urlParam
}
export const pluralize = (value, text, suffix = 's') =>
    +value === 1 ? `${value} ${langTranslate(text)}` : `${value} ${langTranslate(`${text}${suffix}`)}`

export const labelPluralize = (value, text, suffix = 's') =>
    +value === 1 ? `${langTranslate(text)}` : `${langTranslate(`${text}${suffix}`)}`

export const getDetailsPageNameString = (name, id) => {
    return name.replace(/\s+/g, '-').toLowerCase() + '-' + id
}

export const getCdet = (from, to) => {
    return getFormattedDate(from, 'DDMMYY') + '|' + getFormattedDate(to, 'DDMMYY')
}

export const getCDateHotels = (from, to) => {
    return getFormattedDate(from, 'DDMMYY', 'DD/MM/YYYY') + '|' + getFormattedDate(to, 'DDMMYY', 'DD/MM/YYYY')
}

export const getTravellerdet = travellers => {
    let trvlStr = ''
    travellers.map((room, idx, array) => {
        let ageArr = room.children.metadata.map(({ age }) => age)
        trvlStr += room.adults.count + ',' + room.children.count
        trvlStr += ageArr.length ? `-${ageArr}` : ''
        if (idx !== array.length - 1) trvlStr += '|'
    })
    return trvlStr
}
export const replaceQueryInUrl = (browserHistory, searchQuery, type) => {
    const stringify = toQueryString(searchQuery)
    let currentUrl = ''
    if (type == 'h') {
        let DETAILS_URL = searchQuery.name + '?c=' + searchQuery.cDet + '&r=' + searchQuery.travellerDet
        if (searchQuery.ur) {
            DETAILS_URL += '&ur=' + searchQuery.ur
        }
        if (searchQuery.pn === 'cnf') {
            DETAILS_URL += '&pn=' + searchQuery.pn
        }
        browserHistory.location.pathname = `${appPrefix}/hotels/details/`
        // window.location.href = browserHistory.location.pathname + DETAILS_URL
        currentUrl = browserHistory.location.pathname + DETAILS_URL
    } else if ( type == 'mrp' )
    {
        browserHistory.location.pathname = `${appPrefix}/hotels/merchresults`
        // window.location.href = browserHistory.location.pathname + '?' + decodeURIComponent(stringify)
        currentUrl = browserHistory.location
    } 
    else {
        browserHistory.location.pathname = `${appPrefix}/hotels/results`
        // window.location.href = browserHistory.location.pathname + '?' + decodeURIComponent(stringify)
        currentUrl = browserHistory.location
    }
    browserHistory.location.search = decodeURIComponent(stringify)
    browserHistory.push(currentUrl)
}

export const srpAbTestRedirect = (browserHistory, searchQuery, type) => {
    const isBento = getCookie('isBento')
    const stringify = toQueryString(searchQuery)
    let currentUrl = ''
    if (type == 'h') {
        const DETAILS_URL = searchQuery.name + '?c=' + searchQuery.cDet + '&r=' + searchQuery.travellerDet
        browserHistory.location.pathname = `${appPrefix}/hotels/details/`
        // window.location.href = browserHistory.location.pathname + DETAILS_URL
        currentUrl = browserHistory.location.pathname + DETAILS_URL
    } else if ( type == 'mrp' )
    {
        browserHistory.location.pathname = `${appPrefix}/hotels/merchresults`
        // window.location.href = browserHistory.location.pathname + '?' + decodeURIComponent(stringify)
        currentUrl = browserHistory.location
    }
    else {
        browserHistory.location.pathname = `${appPrefix}/hotels/results`
        // window.location.href = browserHistory.location.pathname + '?' + decodeURIComponent(stringify)
        currentUrl = browserHistory.location
    }
    browserHistory.location.search = decodeURIComponent(stringify)
    if (DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN') {
        browserHistory.push(currentUrl)
    } else {
        if (type == 'h') {
            window.location.href = currentUrl
        } else {
            window.location.href = currentUrl.pathname + '?' + decodeURIComponent(stringify)
        }
    }
}

export function debounce(func, delay) {
    return function() {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
            func.apply(this, arguments)
        }, delay)
    }
}

export function throttle(callback, delay, options = {}) {
    let flag = true
    return () => {
        if (flag) {
            flag = false
            setTimeout(() => {
                callback(options)
                flag = true
            }, delay)
        }
    }
}

export function getCookie(name) {
    if (document.cookie) {
        var nameEQ = name + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1, c.length)
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
        }
        return ''
    } else {
        return ''
    }
}

export const setCookie = (name, value, days) => {
    let expires
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = `; expires=${date.toGMTString()}`
    } else {
        expires = ''
    }
    document.cookie = `${name}=${value}${expires}; path=/`
}

export const setPaymentCookie = (name, value, days) => {
    let expires
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = `; expires=${date.toGMTString()}`
    } else {
        expires = ''
    }
    document.cookie = `${name}=${value}${expires}; path=/pay/air`
}

export function deleteCookie(name) {
    setCookie(name, '', -1)
}

export function getCTAuthCookie() {
    return getCookie('usermisc')
}

export function getUserAuthValues() {
    const [email, profileName, gender, photo, userId] = decodeURIComponent(getCookie('userid') || '').split('|')
    return {
        email,
        profileName,
        gender,
        photo,
        userId
    }
}

export const numberWithCommas = number => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const jsonObjectToFormData = obj => {
    const keyArray = Object.keys(obj).map(key => {
        return `${key}=${obj[key]}`
    })
    return keyArray.join('&')
    // TODO: remove these lines at the end
    // var bodyFormData = new FormData()
    // for (let key in obj) {
    //     bodyFormData.set(key, obj[key])
    // }
    // return bodyFormData
}

export const compare = (arr, key, callback) =>
    arr.reduce((prev, curr) => (callback(prev[key], curr[key]) ? prev : curr), {})[key]

//addded for some time
export const currencyFormat = (value, locale = 'en-IN', currency = 'INR') => {
    if (value === 'null') {
        return 'N/A'
    }
    let formatted = parseInt(value, 10).toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0
    })
    formatted = formatted.substring(0, 1) + ' ' + formatted.substring(1, formatted.length)
    return formatted
}

export const currencyPrefix = currencyCode => {
    if (!currencyCode) return
    let currencySymbol = Number()
        .toLocaleString(undefined, { style: 'currency', currency: currencyCode })
        .split('0.00')[0]
    return currencySymbol
}
export const getURLSearchParam = param => {
    let searchParams = resolveKeysInObjectsArrays(['location', 'search'], window) //window.location.search
    if (!isEmpty(searchParams)) {
        searchParams = searchParams.replace('?', '').split('&')
        for (let i = 0; i < searchParams.length; i++) {
            if (searchParams[i].indexOf(param) > -1) {
                const paramVal = searchParams[i].split('=')[1]
                return paramVal
            }
        }
    }
    return
}

export const pageLoadTime = () => {
    if (window) {
        if (window.lastRenderTimeStamp > 0) {
            return new Date().getTime() - window.lastRenderTimeStamp
        } else {
            const time = new Date().getTime() - window.performance.timing.connectStart
            return time > -1 ? time : 0
        }
    } else {
        return 0
    }
}

// LSTORAGE_COUNT_TO_SAVE

export function getFiltersFromLocalStorage(key, emptyVal = '') {
    try {
        // const val = localStorage.getItem(key)
        let configsStr = localStorage.getItem(LSTORAGE_FILTER_DATA_KEY)
        if (!configsStr) return {}
        let filterConfigs = JSON.parse(configsStr)
        // let reqConfig = filterConfigs[key] || {}
        let reqConfig = {}
        if (Array.isArray(filterConfigs)) {
            for (let config of filterConfigs) {
                if (config[key]) reqConfig = config[key]
            }
        }
        // console.log('localStorage - ',reqConfig)
        return reqConfig
        // if (val) return val
    } catch (e) {
        console.log('From LC error - ', e)
        return {}
    }
}

export function setFiltersToLocalStorage(key, val) {
    try {
        if (typeof val === 'object') {
            // TODO Anoop - Add the logic for recent 5 only
            let configsStr = localStorage.getItem(LSTORAGE_FILTER_DATA_KEY)
            let finalFilterConfigs = []
            if (configsStr) {
                finalFilterConfigs = JSON.parse(configsStr)
                if (Array.isArray(finalFilterConfigs)) {
                    let existingKey = false
                    let existingIdx = -1
                    for (let i = 0; i < finalFilterConfigs.length; i++) {
                        const config = finalFilterConfigs[i]
                        if (config[key]) {
                            existingIdx = i
                            existingKey = true
                            break
                        }
                    }
                    if (existingKey) {
                        // splice it
                        const replaceWith = {
                            [key]: val
                        }
                        finalFilterConfigs.splice(existingIdx, 1, replaceWith)
                    } else {
                        finalFilterConfigs.unshift({
                            [key]: val
                        })
                        // Add length logic here
                        if (finalFilterConfigs.length > LSTORAGE_COUNT_TO_SAVE)
                            finalFilterConfigs.splice(finalFilterConfigs.length - 1, 1)
                    }
                } else {
                    finalFilterConfigs = []
                    finalFilterConfigs.push({
                        [key]: val
                    })
                }
            } else {
                finalFilterConfigs.push({
                    [key]: val
                })
            }
            // console.log(finalFilterConfigs)
            // Check if the key exists.
            // Y - then overwrite
            // N - then add to the top
            //      Check if length of array > LSTORAGE_COUNT_TO_SAVE, Y - Delete last entry in array N - Don't Do anything
            // console.log('LSTORAGE_FILTER_DATA_KEY', finalFilterConfigs)
            localStorage.setItem(LSTORAGE_FILTER_DATA_KEY, JSON.stringify(finalFilterConfigs))
        } else logConsole('not object LC')
    } catch (e) {
        console.log('To LC error - ', e)
    }
}

const writeCookieUtm = (k, v, expiryInDays) => {
    if (expiryInDays > 0) {
        const now = new Date()
        const nextDate = now.setDate(now.getDate() + expiryInDays)
        const expiresDate = new Date(nextDate)
        document.cookie = `${k}=${v}; path=/; expires=` + expiresDate
    } else if (!expiryInDays || expiryInDays === '') {
        document.cookie = `${k}=${v};path="/";`
    }
    return null
}

const writeCookieUtmInMinutes = (k, v, expiry) => {
    if(expiry > 0) {
        // Set expiry time in minutes
        let date = new Date();
        date.setTime(date.getTime() + (expiry * 60 * 1000));
        document.cookie = k + "=" + v + "; expires=" + date + "; path=/";
    } else if (!expiry || expiry === '') {
        document.cookie = `${k}=${v};path="/";`
    }
    return null
}

export const readParam = (name, options = {}) => {
    const queryString = window.location.search.split('?')
    const urlHash = fromQueryString(queryString[1] ? queryString[1] : '')
    const params = urlHash ? urlHash : {}

    const cookieValue = getCookie(name || options.alias)
    const value = params[name] || params[options.alias]
    if (name === 'utm_source' && value === 'GoogleHPA') {
        options = {
            ...options,
            expiry: 30 // Expiration time in minutes
        }
    }
    // if value present in param then return that, otherwise check in cookie
    if (value) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        if(name === 'utm_source' && value === 'GoogleHPA') {
            writeCookieUtmInMinutes(name, value, options.expiry || 30)
        } else{
            writeCookieUtm(name, value, options.expiry || 1)
        }
        return value
    } else {
        if (cookieValue) {
            return cookieValue
        }
    }
}

export const FULL_NAMES_OF_DAYS = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
}

export const appPrefix = (() => {
    let langPrefix = ''
    let lang = 'en'
    // const LOCAL_LANG = process.env.LOCALE_LANG
    // const ENGLISH_LANG = 'en'

    const pathname = resolveKeysInObjectsArrays(['location', 'pathname'], window)

    const [, ln = lang] = (pathname || '').split('/')

    if (ln === 'ar') {
        langPrefix = '/ar'
        lang = ln
    }

    return ln === 'ar' ? `${langPrefix}` : ''
})()

//   const appRoutePrefix =  ln === 'ar' ? `${langPrefix}` : ''

export const checkFeatureEnabled = ({ featureConfig = {}, currentSearchQuery = {} }) => {
    const { locale: currentLocale } = getCurrencyByLocale()
    const { enabled = true, locales = [], intl = true, dom = true, roundTrip = null, oneWay = null } = featureConfig

    if (!enabled) {
        return false
    }

    if (intl === false && currentSearchQuery.isIntl) {
        return false
    }

    if (dom === false && currentSearchQuery.isIntl === false) {
        return false
    }

    if (locales.length) {
        if (locales.indexOf(currentLocale) === -1) {
            return false
        }
    }

    if (roundTrip === false && currentSearchQuery.returnDate) {
        return false
    }

    if (oneWay === false && !currentSearchQuery.returnDate) {
        return false
    }

    return true
}

export const arabicDateConverter = (formateDate, year = true, week = true) => {
    try {
        let date = formateDate.split(' ')
        if (!week) {
            return `${langTranslate(date[0])} ${langTranslate(date[1])}`
        }
        let convertedFormate = `${langTranslate(date[0].replace(',', ''))} ,${langTranslate(date[1])} ${langTranslate(
            date[2]
        )} ${langTranslate(date[3])}`
        if (!year) {
            convertedFormate = `${langTranslate(date[0].replace(',', ''))} ,${langTranslate(date[1])} ${langTranslate(
                date[2]
            )}`
        }
        return convertedFormate
    } catch (e) {
        return formateDate
    }
}

export const capitalizedFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
export const capitalizedEachWord = text => {
    const string = text.split(' ')
    const finalString = string
        .map(str => {
            return str[0].toUpperCase() + str.substring(1)
        })
        .join('')

    return finalString
}

export const convertCurrency = (price, currency, currencies) => {
    // let [currencies, setCurrencies] = useContext(CurrencyContext)
    // if (!isEmpty(currencyContext)) {
    //     currencies = currencyContext
    // }
    const conversionRate = !isEmpty(currency)
        ? getConversionRate(currency, currencies.currencyList)
        : currencies.conversionRate
    const { code: currencyCode, rate = '1' } = conversionRate || {}

    let sellingRate = 1
    const { currency: originalCurrency } = getCurrencyByLocale()
    if (!isEmpty(originalCurrency)) {
        const oriCurConvRate = getConversionRate(originalCurrency, currencies.currencyList) || {}
        sellingRate = oriCurConvRate.rate
    }
    let formattedCurrency = formatCurrency({ price, rate, currencyCode, sellingRate })
    return formattedCurrency
}

export function getScript(url, callback) {
    //create a script element and inject it into the page
    var script = document.createElement('script')
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)

    //when the new script's load event fires, execute the callback
    script.onload = callback
}

export const ONWARD_DIR_ARROW = process.env.CONTENT_DIR === 'RTL' ? '←' : '→'

export const formSrpUrl = searchQuery => {
    let pathname = `${appPrefix}/flights/results`
    if (searchQuery.intl && searchQuery.intl === 'y') {
        pathname = `${appPrefix}/flights/international/results`
    }
    const stringify = toQueryString(searchQuery)
    let search = decodeURIComponent(stringify)
    return `${pathname}?${search}`
}
export const getExtension = () => {
    const currentDomain = resolveKeysInObjectsArrays(['location', 'hostname'], window)
    return EXTENTION_BY_DOMAIN[currentDomain] || 'notAvailable'
}

export const userLoggedInObj = () => {
    let IS_EMAIL_EXIST = false
    let IS_USERID_EXIST = false
    let IS_CT_AUTH_EXIST = false

    const { email = '', userId = '' } = getUserAuthValues()

    IS_EMAIL_EXIST = email !== undefined && email.length > 0

    if (userId !== undefined) {
        IS_USERID_EXIST = true
    }

    const ctAuthCookie = getCTAuthCookie()
    if (!isEmpty(ctAuthCookie)) {
        IS_CT_AUTH_EXIST = ctAuthCookie.length > 0
    }

    return {
        isLoggedIn: IS_USERID_EXIST && IS_CT_AUTH_EXIST,
        email,
        userId
    }
}

export const constructHotelDetailsImageUrl = (image, transformations) => {
    let wideImage = ''
    if (image) {
        wideImage = image.replace(/_tn./i, '_w.') // eslint-disable-line
        // wideImage = image.replace(/_w./i, '.') // eslint-disable-line
          wideImage = wideImage.startsWith('/') ? wideImage.slice(1) : wideImage;

    }

    let endPoint

    if (process.env.CDN_ENV == 'production') {
        endPoint = 'ct-hotel-images-live'
    } else {
        endPoint = 'ct-hotel-images-me'
    }
    // Supplier images already contain a full URL (e.g. https://i.travelapi.com/...)
    // Return them as-is to avoid double-prefixing
    if (wideImage && (wideImage.startsWith('http://') || wideImage.startsWith('https://'))) return wideImage;

    if(process.env.CDN_ENV == 'production')
    return `https://ui.cltp.co/places/hotels/${wideImage}`
    else        return `https://qaui.cltp.co/places/hotels/${wideImage}`
}
export const getRatingText = rating => {
    const numberRating = Number(rating).toFixed(0)
    switch (numberRating) {
        case '5':
            return 'Excellent'
        case '4':
            return 'Very Good'
        case '3':
            return 'Average'
        case '2':
            return 'Poor'
        case '1':
            return 'Terrible'
        default:
            return ''
    }
}

export const setCurrencyType = currencies => {
    const getDefaultCurObj = () => {
        const { currency, symbol } = getCurrencyByLocale()
        return currency + '|' + encodingValue(symbol)
    }
    const defaultCurObj = getCookie('utm_currency') || getDefaultCurObj()

    let defaultCurrency = defaultCurObj.split('|')[0]
    let conversionRate = getConversionRate(defaultCurrency, currencies.currencyList)
    return conversionRate
}
export const isUserSignedIn = () => {
    let userObject = getUserAuthValues() || {}
    let usermiscVal = decodeURIComponent(getCookie('usermisc') || '').split('|')
    let signedIn = usermiscVal.includes('SIGNED_IN') && userObject.userId && userObject.userId.length > 0 ? true : false

    return signedIn
}

export const isCtUser = () => {
    const [email] = decodeURIComponent(getCookie('userid') || '').split('|')
    return email.indexOf('@cleartrip.com') > -1
}

export const openDetailsInNewTab = searchQuery => {
    let DETAILS_URL = searchQuery.name + '?c=' + searchQuery.cDet + '&r=' + searchQuery.travellerDet
    if (searchQuery.ur) {
        DETAILS_URL += '&ur=' + searchQuery.ur
    }
    DETAILS_URL = `${appPrefix}/hotels/details/${DETAILS_URL}`
    window.open(DETAILS_URL, '_blank')
}

export const getPopularCities = () => {
    const { locale } = getCurrencyByLocale();
    return {
        p: POPULAR_DESTINATIONS_BY_LOCALE[locale] || DEFAULT_POPULAR_DESTINATIONS
    }
}

export const flatten = arr => {
    let suggestionArr = []
    arr.map((itm, val) => {
        suggestionArr.push({ ...itm, childSuggestions: null })
        if (itm.childSuggestions && itm.childSuggestions.length > 0) {
            itm.childSuggestions.map((childVal, idx) => {
                suggestionArr.push({ ...childVal, tp: 1 })
            })
        }
    })
    return suggestionArr
}
export const getQueryParams = () => {
    let urlSearchParams = window.location.search
    const queryParams = {}
    if (urlSearchParams) {
        urlSearchParams = urlSearchParams.substring(1, urlSearchParams.length)
        const params = urlSearchParams.split('&')
        for (const val in params) {
            const [key, value] = params[val].split('=')
            queryParams[key] = value
        }
    }
    return queryParams
}

export const path = (p, o) => {
    const reducerFunction = (xs, x) => {
        return xs && xs[x] ? xs[x] : null
    }
    return p.reduce(reducerFunction, o)
}
